import { useEffect } from 'react';
import { smartlookIdentify } from '.';
import { useApiContext, useGetFullInfo } from 'react-easyrocket';

export const useSmartlookIdentify = () => {
  const isAuthenticated = useApiContext();
  const { fullInfo } = useGetFullInfo();

  useEffect(() => {
    const userId = `${fullInfo?.id}`;
    const userEmail = fullInfo?.email;

    if (isAuthenticated && userId && userEmail) {
      smartlookIdentify(userId, userEmail);
    }
  }, [isAuthenticated, fullInfo?.id, fullInfo?.email]);
};
